import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchRecipes = createAsyncThunk(
  'recipes/fetchRecipes',
  async ({page = 1, searchTerm='', activeTab=''}) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/recipe-list`, {
      page: page,
      searchTerm:searchTerm,
      activeTab:activeTab
    });
    return response.data;
  }
);

export const fetchRecipeDetail = createAsyncThunk(
  'recipes/fetchRecipeDetail',
  async (recipeId) => {
    const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/customer/recipe/${recipeId}`);
    return response.data;
  }
);

export const toggleFavoriteMeal = createAsyncThunk(
  'recipes/toggleFavoriteMeal',
  async ({ id, category }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/toggle-favorite-meal`, {
      id: id,
      category: category,
    });
    return response.data;
  }
);

export const addToMealPlan = createAsyncThunk(
  'recipes/addToMealPlan',
  async ({ id, category }) => {
    const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/add-meal-to-nutrition-plan`, {
      id: id,
      category: category,
    });
    return response.data;
  }
);

const recipesSlice = createSlice({
  name: 'recipes',
  initialState: {
    recipes: [],
    recipeDetail: {},
    currentPage: 1,
    totalPages: 1,
    isLoading: false,
    errorMessage: '',
    successMessage: '',
    isFavorite:false
  },
   reducers: {
    clearMessage: (state, action) => {
      state.successMessage = '';
      state.errorMessage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecipes.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = '';
      })
      .addCase(fetchRecipes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.recipes = action.payload.data.data;
        state.currentPage = action.payload.data.current_page;
        state.totalPages = action.payload.data.last_page;
      })
      .addCase(fetchRecipes.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      })
      .addCase(fetchRecipeDetail.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = '';
      })
      .addCase(fetchRecipeDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        action.isFavorite = action.payload.data.favourite;
        state.recipeDetail = action.payload.data;
      })
      .addCase(fetchRecipeDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      }) 
      .addCase(toggleFavoriteMeal.fulfilled, (state, action) => {
        state.isLoading = false;
        const { message } = action.payload;
        state.isFavorite = message.includes('added');
      })
      .addCase(addToMealPlan.pending, (state, action) => {
          state.isLoading = false;
      })
      .addCase(addToMealPlan.fulfilled, (state, action) => {
          state.isLoading = false;
          state.successMessage = action.payload.message;
          state.errorMessage = '';
      })
      .addCase(addToMealPlan.rejected, (state, action) => {
          state.isLoading = false;
          state.successMessage = '';
          state.errorMessage = action.payload.message;
      });
  },
});

export const { clearMessage } = recipesSlice.actions;
export default recipesSlice.reducer;